var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"content",staticClass:"cms-content"},[(_vm.getCmsData)?_c('div',{class:['parsed-cms-data', { 'container': _vm.sync }],domProps:{"innerHTML":_vm._s(_vm.parsedCmsData)}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }